import { Component, OnInit, AfterViewInit, ViewChild, Output, EventEmitter, Input, ChangeDetectorRef } from '@angular/core';

import { ModalControl } from '../../../modal-control/modal-control.component';
import { GridColumn, GridExternalFilter } from '../../grid-control.model';
import { NotifyService } from '../../../../services/notify/notify.service';
import { TranslateService } from '../../../../services/translate/translate.service';
import { DeviceDetectorService } from 'ngx-device-detector';
import { QuickFilter } from '../grid-popup-filter/grid-popup-filter.model';

@Component({
  selector: 'sd-grid-popup-quick-filter-detail',
  templateUrl: './grid-popup-quick-filter-detail.component.html',
  styleUrls: ['../../../../assets/css/form.scss',
    '../../../../assets/css/label.scss',
    '../../../../assets/css/scrollbar.scss',
    './grid-popup-quick-filter-detail.component.scss']
})
export class GridPopupQuickFilterDetailComponent implements OnInit, AfterViewInit {
  displayKey = 'SDCUSTOM';
  isMobileOrTablet = false;
  @ViewChild('modal') modal: ModalControl;
  @Input() quickFilters: QuickFilter[];
  @Output() accept = new EventEmitter<any>();
  fields: Field[] = [];
  selectableFields: Field[] = [];
  columns: GridColumn[] = [];
  externalFilters: GridExternalFilter[] = [];
  filter: Filter = {};
  externalFilter: Filter = {};
  selectedField: {
    [key: string]: boolean;
  } = {};
  page: 1 | 2 = 1;
  code: string;
  constructor(
    deviceService: DeviceDetectorService,
    private notifyService: NotifyService,
    private translateService: TranslateService
  ) {
    this.isMobileOrTablet = !deviceService.isDesktop();
  }

  ngOnInit() {
  }

  ngAfterViewInit() {

  }

  open(columns: GridColumn[], externalFilters: GridExternalFilter[], filter?: Filter, externalFilter?: Filter, code?: string) {
    this.fields = [];
    this.filter = {};
    this.externalFilter = {};
    this.columns = columns;
    this.externalFilters = externalFilters;
    this.code = code;
    if (filter) {
      Object.keys(filter).forEach(key => {
        if (filter[key] === undefined || filter[key] === null || filter[key] === '') {
          return;
        }
        const column = columns.find(e => e.field === key);
        if (!column) {
          return;
        }
        this.filter[key] = filter[key];
        this.fields.push({
          ...column,
          id: 'column' + column.field,
          group: 'column',
          type: column.type,
          code: column.field,
          title: column.title
        });
      });
    }
    if (externalFilter) {
      Object.keys(externalFilter).forEach(key => {
        if (externalFilter[key] === undefined || externalFilter[key] === null || externalFilter[key] === '') {
          return;
        }
        if (key.startsWith(this.displayKey)) {
          this.externalFilter[key] = externalFilter[key];
          return;
        }
        const item = externalFilters.find(e => e.field === key);
        if (!item) {
          return;
        }
        if (item.type === 'daterange' || item.type === 'numberrange') {
          this.externalFilter[key] = { ...externalFilter[key] };
          if (!externalFilter[key]?.from && !externalFilter[key]?.to) {
            return;
          }
          this.fields.push({
            ...item,
            id: 'external' + item.field,
            group: 'external',
            type: item.type,
            code: item.field,
            title: item.title,
            fromTitle: item.fromTitle,
            toTitle: item.toTitle,
          });
        } else if (item.type === 'daterangefull') {
          this.externalFilter[key] = { ...externalFilter[key] };
          if (!externalFilter[key]?.from && !externalFilter[key]?.to) {
            return;
          }
          this.fields.push({
            ...item,
            id: 'external' + item.field,
            group: 'external',
            type: item.type,
            code: item.field,
            title: item.title
          });
        } else {
          this.externalFilter[key] = externalFilter[key];
          this.fields.push({
            ...item,
            id: 'external' + item.field,
            group: 'external',
            type: item.type,
            code: item.field,
            title: item.title
          });
        }
      });
    }
    const externalFields: Field[] = externalFilters?.map(e => ({
      ...e,
      id: 'external' + e.field,
      group: 'external',
      code: e.field,
      type: e.type,
      title: e.title
    })) || [];
    const columnFields: Field[] = [];
    columns?.filter(e => e.type !== 'image').forEach(column => {
      if ('children' in column) {
        column.children?.filter(e => e.type !== 'image').forEach(e => {
          columnFields.push({
            ...e,
            id: 'column' + e.field,
            group: 'column',
            code: e.field,
            type: e.type,
            title: e.title
          });
        });
      } else {
        columnFields.push({
          ...column,
          id: 'column' + column.field,
          group: 'column',
          code: column.field,
          type: column.type,
          title: column.title
        });
      }
    });
    this.selectableFields = [...externalFields, ...columnFields];
    this.selectedField = {};
    this.fields.forEach(e => this.selectedField[e.id] = true);
    this.page = this.fields.length > 0 ? 2 : 1;
    this.modal.open();
  }

  onAccept = () => {
    const execute = () => {
      const filter = {};
      const externalFilter = {};
      Object.keys(this.filter).forEach(key => {
        if (this.filter[key] === undefined || this.filter[key] === null || this.filter[key] === '') {
          return;
        }
        if (!this.fields.some(e => e.group === 'column' && e.code === key)) {
          return;
        }
        filter[key] = this.filter[key];
      });
      Object.keys(this.externalFilter).forEach(key => {
        if (this.externalFilter[key] === undefined || this.externalFilter[key] === null || this.externalFilter[key] === '') {
          return;
        }
        externalFilter[key] = this.externalFilter[key];
      });
      this.accept.emit({
        code: this.code,
        filter,
        externalFilter
      });
      this.modal.close();
    };
    if (!this.code) {
      this.notifyService.confirmWithInput('Enter your quick filter name').then((value: string) => {
        if (value) {
          if (this.quickFilters?.some(e => e.code === value)) {
            this.notifyService.notify.warning(this.translateService.translate('Code is existed'));
            return;
          }
          this.code = value;
          execute();
        }
      });
    } else {
      execute();
    }
  }

  onCancel = () => {
    this.modal.close();
  }

  onSelectField = (values: string[]) => {
    this.fields = this.selectableFields.filter(e => values.some(v => e.code === v));
    for (const field of this.fields) {
      if (field.group === 'external' && field.type.includes('range')) {
        this.externalFilter[field.code] = this.externalFilter[field.code] || {};
      }
    }
  }

  onSelectFields = () => {
    this.fields = this.selectableFields.filter(e => this.selectedField[e.id]);
    for (const field of this.fields) {
      if (field.group === 'external' && field.type.includes('range')) {
        this.externalFilter[field.code] = this.externalFilter[field.code] || {};
      }
    }
  }
}

interface Field {
  id: string;
  group: 'column' | 'external';
  type: string;
  code: string;
  title?: string;
  fromTitle?: string;
  toTitle?: string;
  [key: string]: any;
}

interface Filter {
  [field: string]: any;
}
